import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import Alert from 'components/alerts/Alert/Alert';

import { connect } from 'react-redux';
import Loading from 'components/Loading/Loading';
import TeacherReservationList from 'components/TeacherReservationList';
import TeacherPendingReservationList from 'components/TeacherPendingReservationList';
import moment from 'moment-timezone';
import { timezoneDisplayName } from 'utils/timezoneUtils';

import CompleteProfile from './CompleteProfile';
import { activateTeacher, updateProfile } from '../../../actions/userActions';
import { getTimezones } from '../../../actions/Teacher/timezoneActions';

import './style.css';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideTimezoneSuggestion: false,
      timezoneUpdated: false
    };
  }

  profileDataFillStatus = (user) => {
    const listingsWithoutSpecialization = user.listing ?
      user.listing.filter(l => l.specializations.length === 0) :
      0;
    const listingsWithoutAge = user.listing ?
      user.listing.filter(l => l.ageLevels.length === 0) :
      0;

    // When we require video...
    /*
    {
      text: 'Instruction video',
      value: Boolean(user.information && user.information.bioLink)
    }
    */

    // When we require language spoken
    /*
    { text: 'Language spoken', value: user.languages && user.languages.length > 0 },
    */
    const data = [
      { text: 'First & Last name', value: Boolean(user.givenName && user.familyName) },
      { text: 'Skype ID', value: Boolean(user.skypeName) },
      { text: 'Upload profile picture', value: Boolean(user.picture) },
      {
        text: 'Bio description',
        value: Boolean(user.information && user.information.description)
      },
      { text: 'Availability', value: Boolean(user.schedule.length) },
      { text: 'Language taught', value: Boolean(user.listing.length) },
      {
        text: 'Specializations (at least 1 per listing)',
        value: Boolean(user.listing.length && !listingsWithoutSpecialization.length)
      },
      {
        text: 'Age focus (at least 1 per listing)',
        value: Boolean(user.listing.length && !listingsWithoutAge.length)
      }
    ];
    const complete = data.filter(item => !item.value).length === 0;
    return [data, complete];
  }

  showTimezoneUpdateSuccess = () => {
    setTimeout(() => {
      this.setState({ timezoneUpdated: false });
    }, 3000);
    return (
      <Alert className="timezone-updated" alertType="success">
        Timezone Updated
      </Alert>
    );
  }

  renderCompleteProfile(profile, profileDataStatus, complete) {
    if (!profile) {
      return (
        <div className="col-md-12 col-lg-4">
          <Loading />
        </div>
      );
    }
    if (profile && !complete) {
      return (
        <div className="col-md-12 col-lg-4">
          <CompleteProfile user={profile} profileDataStatus={profileDataStatus} />
        </div>
      );
    }
    return null;
  }

  renderTimezoneSuggestion(profile) {
    const cookies = new Cookies();
    const currentTimezone = profile.information.timezone;
    const guessedTimezone = moment.tz.guess();
    const rejectedTimezoneSuggestion = cookies.get('rejectedTimezoneSuggestion');
    if (
      currentTimezone !== guessedTimezone &&
      rejectedTimezoneSuggestion !== guessedTimezone &&
      !this.state.hideTimezoneSuggestion
    ) {
      if (this.props.teacher.timezonesStatus == null) {
        this.props.getTimezones();
      }
      return (
        <Alert className="timezone-suggestion" alertType="warning">
          <h4>Timezone Conflict</h4>
          <div>
            We have detected your timezone has changed. Updating your timezone changes your
            availability to reflect your current timezone.
          </div>
          <div className="suggested-timezone">
            {this.props.teacher.timezones && (
              <strong>{timezoneDisplayName(guessedTimezone, this.props.teacher.timezones)}</strong>
            )}
          </div>
          <button
            type="button"
            className="btn btn-primary btn-blue btn-cursor"
            disabled={this.props.user.updateStatus === 'LOADING'}
            onClick={() => this.props.updateProfile(
              {
                information: { timezone: guessedTimezone }
              },
              false,
              () => {
                this.setState({ timezoneUpdated: true });
              }
            )}
          >
            {this.props.user.updateStatus === 'LOADING' ? 'UPDATING' : 'UPDATE'}
          </button>
          <button
            type="button"
            className="btn btn-primary btn-blue btn-cursor"
            disabled={this.props.user.updateStatus === 'LOADING'}
            onClick={() => {
              cookies.set('rejectedTimezoneSuggestion', guessedTimezone, { path: '/' });
              this.setState({ hideTimezoneSuggestion: true });
            }}
          >
            NO THANKS
          </button>
        </Alert>
      );
    }
    return null;
  }

  render() {
    const { user } = this.props;
    const { profile } = user;
    if (!profile) {
      return <Loading />;
    }

    const [profileDataStatus, complete] = this.profileDataFillStatus(profile);

    return (
      <div className="TeacherHome">
        <div className="card">
          <div className="p-3 p-md-0">
            <div className="row">
              <div className="col-md-12 col-lg-8 mb-3 mb-lg-0">
                <div className="card">
                  <div className="card-block p-5">
                    {this.state.timezoneUpdated && this.showTimezoneUpdateSuccess()}
                    {!this.state.timezoneUpdated &&
                      profile.information &&
                      this.renderTimezoneSuggestion(profile)}
                    {profile.activate && (
                      <div>
                        <h4>{`Welcome back ${profile.name}.`}</h4>
                        <p className="mb-4">Here&#39;s what&#39;s happening on your schedule.</p>
                        <TeacherPendingReservationList source="home" />
                        <TeacherReservationList source="home" />
                      </div>
                    )}
                    {!profile.activate && complete && (
                      <div>
                        {user.error && (
                          <div className="dashboard-error">
                            <Alert alertType="danger">
                              <h5>Error</h5>
                              <p>{user.error}</p>
                            </Alert>
                          </div>
                        )}
                        <p> Click below to activate your profile and start booking lessons</p>
                        <div>
                          <button
                            onClick={this.props.activateTeacher}
                            disabled={user.updateStatus === 'LOADING'}
                            type="button"
                            className="btn btn-secondary btn-cursor"
                          >
                            ACTIVATE {user.updateStatus === 'LOADING' && '...'}
                          </button>
                        </div>
                      </div>
                    )}
                    {!profile.activate && !complete && (
                      <Alert alertType="warning">
                        <h5>Attention</h5>
                        <p>
                          You must fill out all fields before we can activate your listing. See
                          progress on the right.
                        </p>
                      </Alert>
                    )}
                  </div>
                </div>
              </div>
              {this.renderCompleteProfile(profile, profileDataStatus, complete)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    teacher: state.teacher
  };
}

export default connect(
  mapStateToProps,
  {
    activateTeacher,
    getTimezones,
    updateProfile
  }
)(Home);



// WEBPACK FOOTER //
// ./src/pages/teacher/Home/index.js